import {buildField, useFormSelector} from '@eitje/form'
import {t} from '@eitje/bridge'
import {Layout, Text} from '~/components'
import {useModalContext} from '~/components/modal/modal_context'
import {FieldRemoveButton} from '../field_remove_button'
import {useEffect} from 'react'
import './index.less'

export const ClearField = ({field, fieldIndex}) => {
	const {clearableFields, modelKey} = useModalContext()
	const setValues = useFormSelector('setValues')
	const clearValue = clearableFields[field]

	const fieldName = t(`records.${modelKey}.fields.${field}`)

	useEffect(() => {
		setValues({[field]: clearValue})
	}, [field])

	return <ClearFieldInput field={field} fieldName={fieldName} rightElement={<FieldRemoveButton fieldIndex={fieldIndex} />} />
}

const ClearFieldTrigger = ({fieldName}) => (
	<Layout className="multi-action-clear-field-select-trigger">
		<Text t={{key: 'modals.multi_action.clear_field', fieldName}} />
	</Layout>
)

const ClearFieldInput = buildField(ClearFieldTrigger, {className: 'multi-action-clear-field-input', clearIcon: false, label: false})
